import { getBirdviewDashboardViewContent } from './BirdviewDashboardView.utils'

function BirdviewDashboardView({ role, ...skeletonProps }) {
  return getBirdviewDashboardViewContent({
    ...skeletonProps,
    role,
    skeleton: role.skeleton,
  })
}

export default BirdviewDashboardView
